import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/media_query.css";
import "./assets/css/style.css";
import "./assets/css/swap.css";
import ScrollToTop from "./common/ScrollToTop";
import About from "./components/About/About";
import BlogSeven from "./components/Blog/Blog/BlogSeven";
import SingleBlog from "./components/Blog/SingleBlog/SingleBlog";
import Careers from "./components/Career/Career";
import CareerApply from "./components/Career/CareerApply";
import Contact from "./components/Contact/Contact";
import Home from "./components/Home/Home";
import NotFound from "./components/NotFound";
import Portfolio from "./components/Portfolio/Portfolio/Portfolio";
import ServicesPageThree from "./components/Services/Services/ServicesPageThree";


function App() {
  //scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<ServicesPageThree />} />
        {/* <Route path="/single_services" element={<SingleServices />} /> */}
        <Route path="/portfolio" element={<Portfolio />} />
        {/* <Route path="/single_portfolio" element={<SinglePortfolio />} /> */}
        <Route path="/blog" element={<BlogSeven />} />
        <Route path="/blog/:slug" element={<SingleBlog />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/career" element={<Careers />} />
        <Route path="/career/apply/:jobId" element={<CareerApply />} />
        
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
